<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-primary py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Forgot your password?</h1>
              <!-- <p class="text-lead text-white">Welcome to PXL.</p> -->
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <form
            name="register"
            id="register"
            @submit.prevent="forgotPassword(email)"
          >
            <div class="card border-0">
              <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                  <small>Enter your email</small>
                </div>
                <div class="row">
                  <div class="col-md-12 mt-4">
                    <label class="form-control-label">Email</label>
                    <input
                      v-model="email"
                      class="form-control"
                      id="email"
                      type="email"
                      name="email"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 d-flex justify-content-between">
                <base-button
                  @click.prevent="
                    router.push({
                      name: 'Login',
                    })
                  "
                  size="m"
                  type="secondary"
                  >Cancel</base-button
                >
                <base-button native-type="submit" size="m" type="success"
                  >Submit</base-button
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, inject } from "vue";
import { useRouter } from "vue-router";

import {useAuth} from "@/composables/auth";

export default {
  name: "register",
  components: {
  },
  setup() {
    const swal = inject("$swal");
    const email = ref("");

    const { forgotPassword } = useAuth();

    const router = useRouter();

    return {
      router,
      email,
      forgotPassword,
    };
  },
};
</script>
<style></style>
